export function createEnumObject<const T extends readonly string[]>(values: T) {
  return Object.fromEntries(
    values.map((value) => [value.toUpperCase(), value]),
  ) as {
    [K in T[number] as Uppercase<K>]: K;
  };
}
